// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"b1281499","220":"411612f4","373":"bee5bdcc","569":"548f2818","595":"d8e96ee4","966":"08996a6e"}[chunkId] + ".chunk.css";
};